var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShow,
      expression: "isShow"
    }],
    staticClass: "slide-box",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.onClose('mask');
      }
    }
  }, [_c('div', {
    staticClass: "main",
    class: [_vm.type],
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("default")], 2)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };